import { useSelector, useDispatch } from 'react-redux'
import { getSettings } from 'state/selectors'
import { setSettings } from 'state/actions'
import { defer } from 'helpers'
import { Checkbox } from 'components/common'
import ExtraDataRequiredLink from './ExtraDataRequiredLink'

/**
 * Render album meta field
 */
function MetaField() {
  const { displayLabels, displayPopularity, displayTracks, fullAlbumData } =
    useSelector(getSettings)
  const dispatch = useDispatch()

  return (
    <div className="MetaField Settings__field field">
      <label className="label has-text-light">Album metadata</label>
      <div className="control">
        <div className="field">
          <Checkbox
            id="displayLabels"
            label="Display label"
            defaultChecked={displayLabels}
            disabled={!fullAlbumData}
            onChange={(event) =>
              defer(dispatch, setSettings({ displayLabels: event.target.checked }))
            }
          />
          {!fullAlbumData && <ExtraDataRequiredLink>Label data required</ExtraDataRequiredLink>}
        </div>
      </div>
      <div className="control">
        <div className="field">
          <Checkbox
            id="displayPopularity"
            label="Display popularity value"
            defaultChecked={displayPopularity}
            disabled={!fullAlbumData}
            onChange={(event) =>
              defer(dispatch, setSettings({ displayPopularity: event.target.checked }))
            }
          />
          {!fullAlbumData && (
            <ExtraDataRequiredLink>Popularity data required</ExtraDataRequiredLink>
          )}
        </div>
      </div>
      <div className="control">
        <div className="field">
          <Checkbox
            id="displayTracks"
            label="Display number of tracks"
            defaultChecked={displayTracks}
            onChange={(event) =>
              defer(dispatch, setSettings({ displayTracks: event.target.checked }))
            }
          />
        </div>
      </div>
    </div>
  )
}

export default MetaField
